<template>
    <div class="overflow-hidden cursor-pointer" @click="clickCampaign()">
        <div class="campaign-image rounded-10" :style="{'background-image': `url('${campaign.fullImageUrl}')`}"></div>
        <div class="mt-2 flex justify-between">
            <div class="text-16 text-a-brown-502314 text-2-line">{{campaign.name}}</div>
            <div class="flex-shrink-0 text-16 text-a-red-d62300 pl-4" >{{getPointMessage()}}</div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";

import { CampaignType } from "@/helper/StaticValue.js";

export default {
    name: "CampaignItem",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
        isSubscription:     { type: Boolean, default: false },
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            var pointUnit = this.lbl.campaign.point;
            if (this.campaign.type == CampaignType.Buy) {
                return this.campaign.pricePerUnit + " " + this.lbl.campaign.baht;
            } else {
                return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
            }
        },
        clickCampaign: function() {
            this.tracking.event('rewards','click_rewards_lits', `${this.campaign.id}|${this.campaign.name}`, null);
            if (this.isSubscription) {
                this.$router.push(`/subscriptiondetail/${this.campaign.id}`);
            } else {
                this.$router.push('/reward/' + this.campaign.id);
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        @include boxRatio($ratio: 66.66%);
    }
</style>
